export const ItemTypes = {
    FISH: "fish",
    MENUFISH: "menuFish"
};
